import { useState } from 'react';
import ContactSupportModal from './ContactSupportModal';
import { MdHelpOutline } from 'react-icons/md';

const HelpIcon = MdHelpOutline as any;

export default function ContactSupportButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* Hidden on mobile (< 768px), visible on desktop */}
      <div className="hidden md:block fixed bottom-6 right-6 z-50">
        <button
          data-tour="support-button"
          onClick={() => setIsModalOpen(true)}
          className="w-14 h-14 bg-primary hover:bg-primary/90 text-white rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-105"
          aria-label="Contact support"
        >
          <HelpIcon className="w-7 h-7" />
        </button>
      </div>

      <ContactSupportModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
